import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from 'src/app/core/backend-services/http/http.backend-service';

export interface TrainingStatsResponse {
  meta?: {generatedAt:string|null;isStale:boolean;state:'ready'|'pending'|'unavailable';refreshing:boolean};
  totalWins: number | null;
  winStreak: number | null;
  games: {
    [key: string]: {
      easy: { wins: number; total: number };
      medium: { wins: number; total: number };
      hard: { wins: number; total: number };
      /** absent in answers of an older backend */
      expert?: { wins: number; total: number };
    };
  } | null;
}

@Injectable({
  providedIn: 'root',
})
export class TrainingBackendService {
  private readonly BASE_ADDRESS = '/training';

  /**
   * @description constructor of TrainingBackendService
   * @param {HttpBackendService} http - http backend service
   */
  constructor(private http: HttpBackendService) {}

  /**
   * @description gets training statistics
   * @returns {Promise<TrainingStatsResponse>}
   */
  public getStats(): Promise<TrainingStatsResponse> {
    return firstValueFrom(
      this.http.get<TrainingStatsResponse>(`${this.BASE_ADDRESS}/stats`)
    );
  }
  /** Bounded polling of a cheap snapshot endpoint, cancelled with its view. */
  public watchStats(onValue: (value: TrainingStatsResponse) => void, onError: () => void): () => void {
    let stopped = false, attempts = 0, timer: ReturnType<typeof setTimeout>;
    const poll = async () => {
      try {
        const value = await this.getStats();
        if (stopped) return;
        onValue(value);
        if (value.meta?.refreshing && ++attempts < 24) timer = setTimeout(poll, 5000);
      } catch { if (!stopped) onError(); }
    };
    void poll();
    return () => { stopped = true; clearTimeout(timer); };
  }

}
